<template>
  <v-app>
    <v-main>
      <router-view />
      <NotificationProvider />
      <NotificationDialog />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-property-decorator';
import NotificationProvider from './components/NotificationProvider/index.vue';
import NotificationDialog from './components/NotificationDialog/index.vue';
@Options({
  components: {
    NotificationProvider,
    NotificationDialog,
  },
})
export default class App extends Vue {
  beforeMount() {
    this.setScreenSizeVaribales();
    window.addEventListener('resize', this.setScreenSizeVaribales, true);
  }

  private setScreenSizeVaribales() {
    const vh = window.innerHeight * 0.01;
    const vw = window.innerWidth * 0.01;
    const vmin = Math.min(vh, vw);

    document.documentElement.style.setProperty('--vmin', `${vmin}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }
}
</script>

<style lang="scss">
a {
  color: $primary-blue;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
}

.v-application--wrap {
  min-height: 100%;
}

@font-face {
  font-family: 'Roboto';
  src: url('./assets/fonts/Roboto-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'AzeretMono';
  src: url('./assets/fonts/AzeretMono-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'FiraMono';
  src: url('./assets/fonts/FiraMono-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'BebasNeue';
  src: url('./assets/fonts/BebasNeue-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Glory';
  src: url('./assets/fonts/Glory-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lobster';
  src: url('./assets/fonts/Lobster-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Oswald';
  src: url('./assets/fonts/Oswald-Regular.ttf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>
